import { Injectable, ViewChild } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Event, Day } from '../models/event';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage } from '@angular/fire/compat/storage';
import { Guid } from 'guid-typescript';
import { finalize } from 'rxjs/operators';
import { FileMaterial } from '../models/file-material';

@Injectable({
  providedIn: 'root'
})
export class DayService {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public currentEvent: Event;
  public currentDay: Day;

  public isEdit: boolean = false;
  public localTitle: string;
  public spinner: boolean = false;

  private itemDoc: AngularFirestoreDocument<Day>;
  private item: Observable<Day>;

  public dayDataSource: MatTableDataSource<any>;

  public pdfDataSource: MatTableDataSource<any>
  public selectedFile: any = "Nenhum arquivo selecionado.";
  public objectPdf: any = "none";

  constructor(
    private fb: FormBuilder,
    private fs: AngularFireStorage,
    private db: AngularFirestore,
    private snackBar: SnackBarIconService
  ) { }

  setEdit(): any {
    if (this.currentDay && this.currentDay.id) {
  //    console.log("day set edit true: " + this.currentDay.id)
      this.isEdit = true
      this.localTitle = this.currentDay.name
    } else {
      this.isEdit = false;
      //console.log("day set edit false")
      this.localTitle = "Novo Dia"
    }
  }

  select(event_id) {
    let array: Day[] = []
    return this.db.collection<Day>('sbccv_event_days', ref =>
      ref.where('event_id', '==', event_id)
        .where('deleted', '==', false)).snapshotChanges()
      .subscribe((result) => {
        array = result.map(item => {
          let day = new Day();
          day.id = item.payload.doc.id;
          day.event_id = item.payload.doc.data().event_id;
          day.name = item.payload.doc.data().name;
          day.date = item.payload.doc.data().date;
          day.text = item.payload.doc.data().text;
          // day.team = item.payload.doc.data().team;
          day.materials = item.payload.doc.data().materials;
          return day;
        });

        array.sort(this.compareDays)

        this.dayDataSource = new MatTableDataSource(array);
        this.dayDataSource.paginator = this.paginator;
      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  compareDays(a, b) {
    if (a.date > b.date) return 1;
    if (b.date > a.date) return -1;
    return 0;
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Day>('sbccv_event_days/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }


  insert(day: Day) {

    this.spinner = true;
    const entity = this.createDay(day)

    return this.db.collection('sbccv_event_days').add(Object.assign({}, entity))
      .then((result) => {
        // console.log("insert result.id: " + result.id)

        this.isEdit = true;
        entity.id = result.id
        this.currentDay = entity
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
        return result

      })
      .catch((error) => {
        console.log("erro insert day: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  update(id: string, day: Day) {

    this.spinner = true;
    const entity = this.createDay(day)

    return this.db.collection('sbccv_event_days').doc(id).set(Object.assign({}, entity, { merge: true }))
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("erro update day: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  /*
  delete(day_id: any) {
    return this.db.collection('sbccv_event_days').doc(day_id).delete()
      .then((e) => {
        this.snackBar.openSnackBar("Apagado", '', 'success');
      })
      .catch((error) => {
        console.log("erro delete day: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }
*/

  delete(id: string) {

    //in fact, is delete

    this.spinner = true;

    return this.db.collection('sbccv_event_days').doc(id).set({ deleted: true }, { merge: true })
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("erro delete/update day: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  createDay(data: any): Day {

    let day = new Day()
    day.name = data.name;
    //  day.team = data.team;
    day.text = data.text;
    day.date = data.date;
    day.event_id = data.event_id;

    if (!this.isEdit)
      day.deleted = false;

    return day;
  }

  createForm(event, day) {

    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      event_id: new FormControl('', [Validators.required]),
      date: new FormControl('', [Validators.required]),
      name: new FormControl('', [Validators.required]),
      text: new FormControl(''),
      //  team: new FormControl('')
    });

    form.controls.event_id.setValue(event.id);

    if (day) {

      form.controls.id.setValue(day.id);
      form.controls.name.setValue(day.name);
      form.controls.text.setValue(day.text);
      //    form.controls.team.setValue(day.team);


      if (day.date) {
        form.controls.date.setValue(new Date(day.date.seconds * 1000));
      }

    }

    return form

  }

  breadCrumb(value) {

    if (value) {
      if (value.length > 50) {
        return value.substr(0, 50) + " ..."
      } else {
        return value
      }
    } else {
      return "Novo"
    }

  }

  setPdfDataSource() {
    this.pdfDataSource = new MatTableDataSource(this.currentDay.materials)
  }

  uploadFilePdf(file, label) {

    const key = Guid.create() + ".pdf";
    const fsRef: AngularFireStorageReference = this.fs.ref("events/pdfs" + key + ".pdf");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          console.log("uploaded.")
          this.updateFilePdfUrl(key, file, url, label)
        });
      }))
      .subscribe();

  }

  updateFilePdfUrl(key: any, file: any, url: any, data: any) {
    if (!this.currentDay.materials) {
      this.currentDay.materials = []
    } else {
      this.currentDay.materials = this.currentDay.materials.filter((e) => {
        return e.id != key
      })
    }

    const pdf = new FileMaterial()
    pdf.id = key
    pdf.name = data.name
    pdf.original = file.name
    pdf.storage = url

    this.currentDay.materials.push(pdf)

    return this.db.collection('sbccv_event_days').doc(this.currentDay.id)
      .set(JSON.parse(JSON.stringify({ materials: this.currentDay.materials })), { merge: true })
      .then(() => {
        this.setPdfDataSource()
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("day update pdf  error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })


  }

  createPdfForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      original: new FormControl('', [Validators.required]),
      storage: new FormControl(''),
      url: new FormControl(''),
    });

    return form
  }



  makeMsgError(errorsCode) {
    let msgError: string

    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}
